import {useEffect} from 'react';
import {Html5QrcodeScanner} from 'html5-qrcode';
import {Html5Qrcode} from "html5-qrcode";
import './qr-styling.css'
import {enums} from "../../utils/enums";

const qrcodeRegionId = "html5qr-code-full-region";
const createConfig = (props) => {
    let config = {};
    if (props.fps) {
        config.fps = props.fps;
    }
    if (props.qrbox) {
        config.qrbox = props.qrbox;
    }
    if (props.aspectRatio) {
        config.aspectRatio = props.aspectRatio;
    }
    if (props.disableFlip !== undefined) {
        config.disableFlip = props.disableFlip;
    }
    if (props.videoConstraints !== undefined) {
        config.videoConstraints = props.videoConstraints;
    }


    return config;
};

const Html5QrcodePlugin = (props) => {
    let html5QrcodeScanner;
    // html5QrcodeScanner.getCameras()
    useEffect(() => {
        switch (props.desiredScannerState) {
            case enums.PAUSE:
                pauseScanner()
                return
            case enums.RESUME:
                resumeScanner()
        }

    }, [props.desiredScannerState])

    function onScanSuccess(qrCodeMessage) {
        props.setQrCodeResult(qrCodeMessage)
        pauseScanner()
    }

    const startScanner = async () => {
        if (html5QrcodeScanner) {
            html5QrcodeScanner.clear()
        }

        const devices = await Html5Qrcode.getCameras()
        console.log(devices)
        let deviceId = ''
        if (devices.filter(device => device.label.includes('back')).length === 0) {
            deviceId = devices[0].id
        } else {
            deviceId = devices.filter(device => device.label.includes('back'))[0].id
        }
        console.log(deviceId)

        let config = createConfig(props);
        config.videoConstraints = {deviceId: {exact: deviceId}}
        // videoConstraints={{facingMode: {exact: "environment"}}}
        console.log(config)
        const verbose = props.verbose === true;
        html5QrcodeScanner = new Html5QrcodeScanner(
            qrcodeRegionId,
            config,
            verbose
        );

        html5QrcodeScanner.render(
            onScanSuccess,
            props.qrCodeErrorCallback
        );

        props.setIsScanning(true);
    };

    const pauseScanner = () => {
        if (html5QrcodeScanner) {
            html5QrcodeScanner.pause()
        }
    }

    const resumeScanner = () => {
        if (html5QrcodeScanner) {
            html5QrcodeScanner.resume()
        }
    }
    const stopScanner = () => {
        if (html5QrcodeScanner) {
            html5QrcodeScanner.clear().catch((error) => {
                console.error("Failed to clear html5QrcodeScanner. ", error);
            });

            // Remove the HTML elements used by the scanner
            const qrcodeRegion = document.getElementById(qrcodeRegionId);
            if (qrcodeRegion) {
                qrcodeRegion.innerHTML = '';
            }

            props.setIsScanning(false);

            if (props.onStopScanner) {
                props.onStopScanner();
            }
        }
    };

    // useEffect(() => {
    //     // Cleanup function when component will unmount
    //     return () => {
    //         pauseScanner();
    //     };
    // }, [props]);

    useEffect(() => {
        if (props.isScanning) {
            console.log('starting scanner')
            startScanner()
        }
    }, [props.isScanning])

    return (
        <div id={qrcodeRegionId}/>
    );
};

export default Html5QrcodePlugin;
